var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PrazoDoDossie.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-53cd2702\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PrazoDoDossie.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/PrazoDoDossie.vue
// module id = 1047
// module chunks = 1